import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDeactivateUserHandler } from '../dataHandlers/deactivateUserHandler';
import { useActivateUserHandler } from '../dataHandlers/activateUserHandler';
import { useResendInviteHandler } from '../dataHandlers/resendInviteHandler';

export default function UserActions({ user, onEdit }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { mutate: deactivateUser, isPending: isDeactivating } = useDeactivateUserHandler();
  const { mutate: activateUser, isPending: isActivating } = useActivateUserHandler();
  const { mutate: resendInvite, isPending: isResending } = useResendInviteHandler();

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDeactivate = () => {
    deactivateUser(user.id);
    handleMenuClose();
  };

  const handleActivate = () => {
    activateUser(user.id);
    handleMenuClose();
  };

  const handleEdit = () => {
    onEdit(user);
    handleMenuClose();
  };

  const handleResend = () => {
    resendInvite(user.id);
    handleMenuClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleMenuOpen} aria-label="More actions">
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        {user.status === 'active' && (
          <MenuItem onClick={handleDeactivate} disabled={isDeactivating}>
            Deactivate
          </MenuItem>
        )}
        {user.status === 'inactive' && (
          <MenuItem onClick={handleActivate} disabled={isActivating}>
            Activate
          </MenuItem>
        )}
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        {user.status === 'invited' && (
          <MenuItem onClick={handleResend} disabled={isResending}>
            Resend Invite
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
